import React from 'react';
import { Route } from 'react-router-dom';
import { Route as NeoRoute } from '~/Constants/Routes.constants';
import { MerchantList } from './MerchantList';
import { EditMerchant } from './EditMerchant';

export const OrganisationMerchant = () => (
  <>
    <Route exact path={NeoRoute.ORGANISATION_MERCHANT}>
      <MerchantList />
    </Route>
    <Route component={EditMerchant} exact path={NeoRoute.ORGANISATION_MERCHANT_SETTING} />
  </>
);
